export enum YesOrNoEnum {
  YES = 'YES',
  NO = 'NO'
}
